import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import makeStyles from '@mui/styles/makeStyles';
import { ModuleNames } from "../../../OrderFlowProvider/OrderFlowTypes";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
export const useHTMLStyles = makeStyles((theme) => {
    return {
        htmlModule: {
            "& div": theme.typography.body1,
            "& h1": theme.typography.h1,
            "& h2": theme.typography.h2,
            "& h3": theme.typography.h3,
            "& h4": theme.typography.h4,
            "& p": theme.typography.body1,
            "& .primary-text": {
                color: theme.palette.primary.main,
            },
            "& .primary-bg": {
                backgroundColor: theme.palette.primary.main,
                color: "white",
                padding: "10px",
                borderRadius: "2px",
            },
            "& .secondary-text": {
                color: theme.palette.secondary.main,
            },
            "& .secondary-bg": {
                backgroundColor: theme.palette.secondary.main,
                color: "white",
                padding: "10px",
                borderRadius: "2px",
            },
        },
    };
});
const useHtml = (sequenceNumber) => {
    var _a;
    const { store } = useOrderFlow();
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((module) => module.ModuleName === ModuleNames.HTML && module.Sequence === sequenceNumber && module.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    return {
        InnerHtml: moduleConfig.InnerHtml,
    };
};
/**
 * Html - This displays the HTML found in moduleConfig. Combinations of the htmlModule classes make up the "format block" choices found in the KMS HTML module Jodit editor.
 * @param {HtmlModuleConfig} moduleConfig
 * @returns {ReactElement} React Element
 */
export const Html = ({ sequenceNumber }) => {
    const classes = useHTMLStyles();
    const { InnerHtml } = useHtml(sequenceNumber);
    return _jsx(Box, { width: "100%", className: classes.htmlModule, dangerouslySetInnerHTML: { __html: InnerHtml } });
};
